import api from '@/api';
import { API_BASE_URL } from '../../index';
import { DailyMovementRequest } from './dailyMovement.types';

const CONTROLLER_URL = `${API_BASE_URL}/generate`;

export async function getDailyMovement(params: DailyMovementRequest) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/daily-movement`,
    params,
  )) as unknown;

  return result as BlobPart;
}
